/**
 * Determine which item type is non-null in ApiDashboardItem
 * @param {ApiDashboardItem} item - The item to check
 * @returns {{ type: string | null, data: any }} The item type and its data
 */
export const getDashboardItemType = (item) => {
  if (!item) return { type: null, data: null };

  if (item.text) return { type: 'text', data: item.text };
  if (item.table) return { type: 'table', data: item.table };
  if (item.chartLine) return { type: 'chartLine', data: item.chartLine };
  if (item.chartBar) return { type: 'chartBar', data: item.chartBar };
  if (item.chartPie) return { type: 'chartPie', data: item.chartPie };
  if (item.progress) return { type: 'progress', data: item.progress };
  if (item.actions) return { type: 'actions', data: item.actions };
  if (item.iframe) return { type: 'iframe', data: item.iframe };
  if (item.code) return { type: 'code', data: item.code };
  if (item.boolean) return { type: 'boolean', data: item.boolean };
  if (item.image) return { type: 'image', data: item.image };
  if (item.list) return { type: 'list', data: item.list };

  return { type: null, data: null };
};
